import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import FrozenVegsFruitsProduct from 'models/FrozenVegsFruitsProduct'
import FrozenVegsFruitsPackage from './FrozenVegsFruitsPackage'

const productOptions = {
  packagingInfo: <FrozenVegsFruitsPackage />,
  productTitle: 'Frozen Fruits/Vegetables',
  model: FrozenVegsFruitsProduct,
  validCategories: ['19'],
  validSubCategories: ['001FF', '001FV'],
}

const FrozenFruits = () => <ProductForm product={productOptions} />

export default FrozenFruits

export const getFrozenVegFruitsPackage = newProduct => {
  let newFrozenVegFruitsPackage = {
    UPC: newProduct.UPC,
    FrozenProductType: newProduct.FrozenProductType,
    Size: newProduct.Size,
    OrganicVerification: newProduct.OrganicVerification,
    FrozenPackageCertification: newProduct.FrozenPackageCertification,
    ItemType:
      newProduct.ItemType === 'Other'
        ? newProduct.otherType
        : newProduct.ItemType,
    PackageType:
      newProduct.PackageType === 'Other'
        ? newProduct.otherPackageType
        : newProduct.PackageType,
  }
  return newFrozenVegFruitsPackage
}
export const updateFrozenVegFruitsPackage = newProduct => {
  let newFrozenVegFruitsPackage = {
    UPC: newProduct.UPC,
    ItemType:
      newProduct.ItemType === 'Other'
        ? newProduct.otherType
        : newProduct.ItemType,
    PackageType:
      newProduct.PackageType === 'Other'
        ? newProduct.otherPackageType
        : newProduct.PackageType,
    Size: newProduct.Size,
    OrganicVerification: newProduct.OrganicVerification,
    FrozenPackageCertification: newProduct.FrozenPackageCertification,
    FrozenProductType: newProduct.FrozenProductType,
  }
  // newFrozenVegFruitsPackage.FrozenProductType = newProduct.FrozenProductType
  console.log(
    'updated product is: ' + JSON.stringify(newFrozenVegFruitsPackage)
  )
  return newFrozenVegFruitsPackage
}
